module.exports = __webpack_public_path__ + "img/stick_divers_commerce.a2165125.svg";